import type { ResponsiveProp } from '@/lib/device/useBreakpoint'
import '../button/Button.css'

export const buttonVariants = [
  'primary',
  'secondary',
  'tertiary',
  'quaternary',
  'link',
  'link-highlighted',
  'positive',
  'negative',
] as const
export type ButtonVariant = (typeof buttonVariants)[number]

export const buttonSizes = ['sm', 'md', 'lg'] as const
export type ButtonSize = (typeof buttonSizes)[number]

export function buttonResponsiveClasses(
  value: ResponsiveProp<string | boolean>,
  prefix: string,
): string[] {
  const resolve = (raw: string | boolean): string[] => {
    if (typeof raw === 'string') {
      return [`${prefix}-${raw}`]
    }

    if (raw === true) {
      return [`${prefix}`]
    }

    return []
  }

  return typeof value === 'object'
    ? Object.entries(value).flatMap(([breakpoint, raw]) =>
        resolve(raw).map((className) => `${className}--${breakpoint}`),
      )
    : resolve(value)
}
